import { PrivateRoutes } from '@enums/privateRouteEnums';
import { PrivateRoutesTitles } from '@enums/privateRoutesTitles';

export const menuConstants = [
  {
    key: PrivateRoutesTitles.OVERVIEW,
    title: PrivateRoutesTitles.OVERVIEW,
    path: PrivateRoutes.ROOT,
    icon: false,
  },
  {
    key: PrivateRoutesTitles.LOAN_HISTORY,
    title: PrivateRoutesTitles.LOAN_HISTORY,
    path: PrivateRoutes.HISTORY,
    icon: false,
  },
  {
    key: PrivateRoutesTitles.DOCUMENTS,
    title: PrivateRoutesTitles.DOCUMENTS,
    path: PrivateRoutes.DOCUMENTS,
    icon: false,
  },
  {
    key: PrivateRoutesTitles.MESSAGES,
    title: PrivateRoutesTitles.MESSAGES,
    path: PrivateRoutes.MESSAGES,
    icon: false,
  },
];
